// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* !important on color/text-decoration to override .app-menu a in _type.scss */

.clearButton--L4xUb {
  color: #000 !important;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: museo-sans;
  font-size: 14px;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none !important;
}

[dir] .clearButton--L4xUb {
  background: #c3c3c3;
  border: 1px solid #343c42;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.clearButton--L4xUb:hover {
  color: #000 !important;
}

[dir] .clearButton--L4xUb:hover {
  background: #b0b0b0;
}

.showButton--xLYSu {
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: museo-sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none !important;
}

[dir] .showButton--xLYSu {
  background: #e6512d;
  border: 1px solid #e6512d;
  padding: 6px 30px;
  border-radius: 4px;
  cursor: pointer;
}

.showButton--xLYSu:hover {
  color: #fff !important;
}

[dir] .showButton--xLYSu:hover {
  background: #cc4425;
}

.clearIcon--cIAuy {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: #fff;
  box-sizing: border-box;
}

[dir] .clearIcon--cIAuy {
  background: #343c42;
  border-radius: 50%;
  padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/ShowClearButtons/styles.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EAEE,sBAAsB;EAEtB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EAET,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EAGzB,gCAAgC;AAClC;;AAfA;EACE,mBAAmB;EAEnB,yBAAyB;EAIzB,iBAAiB;EAKjB,kBAAkB;EAClB,eAAe;AAEjB;;AAEA;EAEE,sBAAsB;AACxB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EAEE,sBAAsB;EAEtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EAER,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EAGjB,gCAAgC;AAClC;;AAfA;EACE,mBAAmB;EAEnB,yBAAyB;EAIzB,iBAAiB;EAKjB,kBAAkB;EAClB,eAAe;AAEjB;;AAEA;EAEE,sBAAsB;AACxB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EAEd,WAAW;EAGX,sBAAsB;AACxB;;AATA;EAIE,mBAAmB;EAEnB,kBAAkB;EAClB,YAAY;AAEd","sourcesContent":["/* !important on color/text-decoration to override .app-menu a in _type.scss */\n\n.clearButton {\n  background: #c3c3c3;\n  color: #000 !important;\n  border: 1px solid #343c42;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  font-family: museo-sans;\n  font-size: 14px;\n  font-weight: 300;\n  text-transform: uppercase;\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none !important;\n}\n\n.clearButton:hover {\n  background: #b0b0b0;\n  color: #000 !important;\n}\n\n.showButton {\n  background: #e6512d;\n  color: #fff !important;\n  border: 1px solid #e6512d;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 30px;\n  font-family: museo-sans;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none !important;\n}\n\n.showButton:hover {\n  background: #cc4425;\n  color: #fff !important;\n}\n\n.clearIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  background: #343c42;\n  color: #fff;\n  border-radius: 50%;\n  padding: 5px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clearButton": `clearButton--L4xUb`,
	"showButton": `showButton--xLYSu`,
	"clearIcon": `clearIcon--cIAuy`
};
export default ___CSS_LOADER_EXPORT___;
